export default "__VITE_ASSET__Fm0anKWl__"